// extracted by mini-css-extract-plugin
export var attachment = "_r2-a";
export var emailContainer = "_r2-4";
export var emailContentPaddedContainer = "_r2-b";
export var emailHeader = "_r2-6";
export var emailIframe = "_r2-3";
export var emailInfoIcon = "_r2-9";
export var emailShortenedSummary = "_r2-e";
export var infoDropdown = "_r2-0";
export var infoRowBoundedContent = "_r2-d";
export var internal = "_r2-5";
export var merchant = "_r2-8";
export var messageInputContainer = "_r2-h";
export var normal = "_r2-7";
export var replyCard = "_r2-f";
export var subtleButton = "_r2-1";
export var subtleButtonIconContainer = "_r2-2";
export var toggleViewRepliesButton = "_r2-c";
export var wrappingText = "_r2-g";